import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { TfiEye } from "react-icons/tfi";
import Swal from "sweetalert2";

export const Registrarse = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    confirmEmail: "",
    password: "",
    confirmPassword: "",
    documentType: "",
    documentNumber: "",
    phone: "",
  })

  const [error, setError] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Manejar cambios en inputs
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "document") {
      const onlyNumbers = value.replace(/\D/g, "").slice(0, 7);
      setForm((prev) => ({ ...prev, [name]: onlyNumbers }));
      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Limpiar error cuando el usuario escribe
    setError((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // Manejar cambio del PhoneInput
  const handlePhoneChange = (value) => {
    setForm((prev) => ({
      ...prev,
      phone: value,
    }));
    setError((prev) => ({
      ...prev,
      phone: "",
    }));
  };

  // Validar formulario
  const validate = () => {
    const newErrors = {};

    if (!form.name.trim()) newErrors.name = "El nombre es obligatorio";

    if (!form.email.trim()) newErrors.email = "El correo es obligatorio";
    else if (!/\S+@\S+\.\S+/.test(form.email))
      newErrors.email = "El correo no es válido";

    if (!form.emailConfirm.trim())
      newErrors.emailConfirm = "Confirme su correo electrónico";
    else if (form.email !== form.emailConfirm)
      newErrors.emailConfirm = "Los correos no coinciden";

    if (!form.password) newErrors.password = "La contraseña es obligatoria";
    else if (
      !/^(?=.*[A-Z])(?=.*\d)(?=.*[@%!?&])[A-Za-z\d@%!?&]{7,}$/.test(form.password)
    )
      newErrors.password =
        "La contraseña debe tener mínimo 7 caracteres, una mayúscula, un número y un símbolo (@%!?&)";

    if (!form.passwordConfirm)
      newErrors.passwordConfirm = "Confirme su contraseña";
    else if (form.password !== form.passwordConfirm)
      newErrors.passwordConfirm = "Las contraseñas no coinciden";

    if (!form.documentType)
      newErrors.documentType = "Seleccione un tipo de documento";

    if (!form.document.trim())
      newErrors.document = "El documento es obligatorio";
    else if (form.document.length !== 7)
      newErrors.document = "El documento debe tener exactamente 7 dígitos";

    if (!form.phone || form.phone.length < 10)
      newErrors.phone = "El teléfono es obligatorio y debe ser válido";

    return newErrors;
  };

  // Mostrar los campos vacíos con error en Swal
  const handleCrearCuenta = (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors);

      // Construir mensaje con los campos que tienen error
      const mensajes = Object.values(validationErrors).join("<br>");

      Swal.fire({
        icon: "error",
        title: "Faltan campos o hay errores:",
        html: mensajes,
        confirmButtonColor: "#d33",
      });

      return false;
    }

    // Si no hay errores:
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Cuenta creada correctamente",
      showConfirmButton: false,
      timer: 2000,
    });

    console.log("Formulario válido y listo para enviar", form);
  };

  return (
    <div className="register-container font-family-montserrat">
      <h2 className="font16 color-520FDA extrabold-800" style={{ width: '100%' }}>
        REGISTRARSE
      </h2>

      <form className="contacto-form container-100 txt-start" onSubmit={handleCrearCuenta}>
        <div className="form-grupo mrg-r-50">
          <label htmlFor="name">Nombre y Apellido</label>
          {/* <input type="text" id="name" name="name" className="form-input" /> */}
          <input
            type="text"
            id="name"
            name="name"
            className="form-input"
            value={form.name}
            onChange={handleChange}
          />
          {error.name && <p className="error-text">{error.name}</p>}
        </div>
        <div className="form-grupo mrg-bottom19">
          <label htmlFor="email" className="txt-start">
            Correo electrónico
          </label>
          {/* <input type="email" id="email" className="form-input" /> */}
          <input
            type="email"
            id="email"
            name="email"
            className="form-input"
            value={form.email}
            onChange={handleChange}
          />
          {error.email && <p className="error-text">{error.email}</p>}
        </div>
        <div className="form-grupo mrg-bottom19 mrg-r-50">
          <label htmlFor="email" className="txt-start">
            Confirmar correo electrónico
          </label>
          {/* <input type="email" id="email" className="form-input" /> */}
          <input
            type="email"
            id="emailConfirm"
            name="emailConfirm"
            className="form-input"
            value={form.emailConfirm}
            onChange={handleChange}
          />
          {error.emailConfirm && <p className="error-text">{error.emailConfirm}</p>}
        </div>
        <div className="form-grupo position-relative">
          <label htmlFor="password" className="txt-start">
            Contraseña*
          </label>
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            name="password"
            className="form-input"
            value={form.password}
            onChange={handleChange}
            required
          />
          <span
            className="eyes-icon"
            style={{ cursor: "pointer" }}
            onClick={() => setShowPassword(!showPassword)}
          >
            <TfiEye size={29} style={{ color: "C1C1C1" }} />
          </span>
          {error.password && <p className="error-text">{error.password}</p>}
        </div>
        <div className="form-grupo position-relative mrg-r-50">
          <label htmlFor="password" className="txt-start" required>
            Confirmar Contraseña*
          </label>
          <input
            type={showConfirmPassword ? "text" : "password"}
            id="passwordConfirm"
            name="passwordConfirm"
            className="form-input"
            value={form.passwordConfirm}
            onChange={handleChange}
          />
          <span
            className="eyes-icon"
            style={{ cursor: "pointer" }}
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            <TfiEye size={29} style={{ color: "C1C1C1" }} />
          </span>
          {error.passwordConfirm && <p className="error-text">{error.passwordConfirm}</p>}
          <div className="label-password">
            Su contraseña debe contener mínimo 7 dígitos, al menos una letra
            Mayúscula, número y símbolos, tales como @%!?&
          </div>
        </div>
        <div className="form-grupo">
          <label htmlFor="document-type">Tipo de Documento*</label>
          <select
            id="documentType"
            name="documentType"
            className="form-input color-454545 font07rem"
            value={form.documentType}
            onChange={handleChange}
          >
            <option value="">Seleccione..</option>
            <option value="dni">Dni</option>
            <option value="pasaporte">Pasaporte</option>
          </select>
          {error.documentType && <p className="error-text">{error.documentType}</p>}
        </div>
        <div className="form-grupo mrg-r-50">
          <label htmlFor="document">N° de Documento*</label>
          <input
            type="text"
            id="document"
            name="document"
            className="form-input input-documento"
            placeholder="Ingresa tu N° de Documento"
            value={form.document}
            onChange={handleChange}
          />
          {error.document && <p className="error-text">{error.document}</p>}
        </div>
        <div className="form-grupo">
          <label htmlFor="phone">TELÉFONO*</label>
          <div className="phone-input-container">
            <PhoneInput
              country={"pe"}
              onlyCountries={["pe"]}
              value={form.phone}
              onChange={handlePhoneChange}
              inputProps={{
                name: "phone",
                required: true,
                autoFocus: true,
                className: "form-input form-input-contactanos",
              }}
            />
          </div>
          {error.phone && <p className="error-text">{error.phone}</p>}
        </div>
      </form>
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem", marginTop: "2rem" }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button type="submit" id="registrarse-button">
            Crear cuenta
          </button>
        </div>
        <div className="registro-link color757575">
          ¿Ya tienes una cuenta?{" "}
          <a href="#" className="color757575">
            Inicie sesión aquí
          </a>
        </div>

      </div>
    </div>
  );
};
